<div class="section-forms" [formGroup]="formGroup">
    <div class="row">
        <div class="form-group col-md-6">
            <app-form-item [field]="fields.isin" [focus]="isin">
                <input class="form-control" type="text" [formControlName]="fields.isin"
                    [placeholder]="placeholder(fields.isin) | translate" component #isin />
            </app-form-item>
        </div>
    </div>
</div>